<h2 mat-dialog-title>Politique de Confidentialité de {{subdomain}}:</h2>
<mat-dialog-content class="mat-typography">
  <h3>Dernière mise à jour : 12 octobre 2024</h3>
  <p>
    La société {{subdomain}}, soucieuse de la protection de la vie privée et des
    données à caractère personnel, s'engage à assurer la sécurité des
    informations collectées auprès de ses Utilisateurs.
  </p>

  <h3>1. Collecte des données</h3>
  <p>
    Lors de l'utilisation du site {{subdomain}} ou des bornes automatiques, nous
    collectons des informations personnelles telles que les noms, prénoms,
    adresses de contact, informations de paiement, ainsi que les préférences de
    course (nombre de passagers, bagages, etc.).
  </p>

  <h3>2. Utilisation des données</h3>
  <p>
    Les données collectées sont utilisées pour fournir les services de
    réservation de taxis, pour améliorer nos services, et pour vous informer des
    modifications de nos services et offres. Elles peuvent également être
    utilisées pour des raisons légales ou de sécurité.
  </p>

  <h3>3. Partage des données</h3>
  <p>
    {{subdomain}} ne partage pas les informations personnelles des Utilisateurs
    avec des tiers à des fins commerciales sans leur consentement. Toutefois,
    des données peuvent être partagées avec nos partenaires pour le bon
    déroulement des services (notamment les chauffeurs et les partenaires de
    paiement).
  </p>

  <h3>4. Durée de conservation des données</h3>
  <p>
    Les données sont conservées aussi longtemps que nécessaire pour la
    prestation des services, ou conformément aux exigences légales.
  </p>

  <h3>5. Sécurité des données</h3>
  <p>
    Nous prenons les mesures techniques et organisationnelles appropriées pour
    protéger vos données contre toute perte, utilisation détournée, accès non
    autorisé, divulgation ou altération.
  </p>

  <h3>6. Vos droits</h3>

  <p>
    En tant qu'Utilisateur, vous avez le droit d'accéder à vos données, de les
    corriger ou de les supprimer. Pour toute demande d'exercice de ces droits,
    vous pouvez nous contacter à l'adresse suivante : hi {{ subdomain }}.
  </p>

  <h3>7. Cookies</h3>

  <p>
    Le site utilise des cookies pour améliorer l'expérience utilisateur et
    analyser le trafic. Vous pouvez configurer votre navigateur pour refuser les
    cookies ou les supprimer après chaque session.
  </p>

  <h3>8. Modification de la politique</h3>

  <p>
    Cette politique peut être modifiée à tout moment. Nous vous recommandons de
    consulter régulièrement cette page pour prendre connaissance de toute
    modification éventuelle. Pour toute question relative à cette politique de
    confidentialité, contactez-nous à l'adresse suivante : hi {{ subdomain }}.
  </p>
</mat-dialog-content>

<mat-dialog-actions>
  <!-- <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Install</button> -->
  <button mat-button color="primary" (click)="close()" cdkFocusInitial>
    Close
  </button>
</mat-dialog-actions>
